import { EditorPreset } from '../types';

/** Data-only — the Toolbar reads this and renders the buttons. `question` | `answer` | `minimal`. */
export interface ToolbarButton {
  id:
    | 'bold'
    | 'italic'
    | 'underline'
    | 'strike'
    | 'code'
    | 'heading'
    | 'bulletList'
    | 'orderedList'
    | 'taskList'
    | 'blockquote'
    | 'codeBlock'
    | 'image'
    | 'math'
    | 'textAlignLeft'
    | 'textAlignCenter'
    | 'textAlignRight'
    | 'highlight'
    | 'undo'
    | 'redo'
    | 'divider';
}

const div: ToolbarButton = { id: 'divider' };

export const TOOLBAR_PRESETS: Record<EditorPreset, ToolbarButton[]> = {
  question: [
    { id: 'undo' },
    { id: 'redo' },
    div,
    { id: 'heading' },
    { id: 'bold' },
    { id: 'italic' },
    { id: 'underline' },
    { id: 'strike' },
    { id: 'highlight' },
    div,
    { id: 'bulletList' },
    { id: 'orderedList' },
    { id: 'taskList' },
    { id: 'blockquote' },
    { id: 'codeBlock' },
    div,
    { id: 'textAlignLeft' },
    { id: 'textAlignCenter' },
    { id: 'textAlignRight' },
    div,
    { id: 'image' },
    { id: 'math' },
  ],

  answer: [
    { id: 'bold' },
    { id: 'italic' },
    { id: 'underline' },
    div,
    { id: 'bulletList' },
    { id: 'orderedList' },
    div,
    { id: 'image' },
    { id: 'math' },
  ],

  minimal: [
    { id: 'bold' },
    { id: 'italic' },
    { id: 'math' },
  ],
};
